import React from 'react'
import PropTypes from 'prop-types'
//import {objectWithoutProperties} from '../../../../utils/utils'
//import classNames from 'classnames';
import {
    Card,
    CardBody, 
    CardHeader,
    Button
} from 'reactstrap'


//================ Property Value Type =====================
const propType={
    hasSetting:PropTypes.bool,
    children:PropTypes.node,
    className: PropTypes.string,
}

//================ Property Default Value =====================
const defaultProps={
    hasSetting:false,
    className: "",
}


const exCard=(props)=>{

    const _props=props,
        className=_props.className,
        children=_props.children,
        hasSetting=_props.hasSetting;
        //attribute = objectWithoutProperties(_props, 'className', 'children')

    

    return  <Card className={className}>
                <CardHeader>
                    <i className="fa fa-align-justify"></i> {props.title}
                    <div className="card-header-actions">
                        {
                            hasSetting
                                ?<Button color="link" className="card-header-action btn-setting" onClick={props.onSettingClick}><i className="icon-settings"></i></Button>
                                :null
                        }
                    </div>
                </CardHeader>
                <CardBody>
                    {children}
                </CardBody>
            </Card>

}



export default exCard;

exCard.defaultProps = defaultProps;
exCard.propTypes = propType;